// Rendered when Angular bootstrap fails (e.g. GET /api/hub kept failing), so it must be
// framework-free: no components, no Transloco (hence static English), plain DOM only —
// including the inline neutral colors, since no theme/customization ever loaded.
export function renderBootstrapError(options: { reload?: () => void } = {}): void {
  const reload: () => void = options.reload || ((): void => window.location.reload());
  const existing: HTMLElement | null = document.getElementById('ac-bootstrap-error');
  if (existing) {
    existing.remove();
  }

  const page: HTMLDivElement = document.createElement('div');
  page.id = 'ac-bootstrap-error';
  page.setAttribute('role', 'alert');
  page.setAttribute('data-testid', 'bootstrap-error-page');
  page.style.cssText =
    'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;' +
    'min-height:100vh;padding:24px;text-align:center;background:#fff;color:#333;' +
    'font-family:Roboto,system-ui,-apple-system,sans-serif;';

  const heading: HTMLHeadingElement = document.createElement('h1');
  heading.setAttribute('data-testid', 'bootstrap-error-heading');
  heading.textContent = "We couldn't load this page";
  heading.style.cssText = 'margin:0;font-size:24px;font-weight:500;';

  const body: HTMLParagraphElement = document.createElement('p');
  body.setAttribute('data-testid', 'bootstrap-error-body');
  body.textContent = 'Something went wrong while loading this page. Please try again.';
  body.style.cssText = 'margin:0;font-size:16px;max-width:480px;';

  const button: HTMLButtonElement = document.createElement('button');
  button.type = 'button';
  button.setAttribute('data-testid', 'bootstrap-error-button-try-again');
  button.textContent = 'Try again';
  button.style.cssText =
    'margin-top:12px;padding:10px 24px;font-size:16px;border:1px solid #767676;border-radius:4px;' +
    'background:#fff;color:#333;cursor:pointer;';
  button.addEventListener('click', reload);

  page.appendChild(heading);
  page.appendChild(body);
  page.appendChild(button);
  document.body.appendChild(page);
}
